export default "__VITE_ASSET__DcNv_YZZ__"